export function selectValue(
  values: any[],
  errorMessage: string
): Error | undefined {
  if (values.length === 0) {
    return new Error(errorMessage);
  }
}
